import type { FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { FormProps } from '@/hooks/useZodForm';
import { Checkbox } from '../Checkbox';
import { FieldLabel } from './FieldLabel';

interface FormCheckboxProps<TData extends FieldValues> {
  label: string;
  fieldName: FieldPath<TData>;
  formProps: FormProps<TData>;
}

export function FormCheckbox<TData extends FieldValues>(props: FormCheckboxProps<TData>) {
  const { label, fieldName, formProps } = props;
  const { errors } = formProps;
  const error = errors[fieldName]?.message as string | undefined;

  return (
    <Controller
      control={formProps.control}
      name={fieldName}
      render={({ field }) => (
        <div className="flex items-center gap-2 cursor-pointer">
          <Checkbox checked={field.value} onCheckedChange={field.onChange} />
          <FieldLabel label={label} error={error} />
        </div>
      )}
    />
  );
}
